import styled from 'styled-components';
import {
  TextField,
} from '@mui/material';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 60px;
`;

const Title = styled.div`
  flex: 1;
  font-size: 24px;
  white-space: nowrap;
  text-align: center;
  margin: 20px;
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 20px;
  width: 100%;
`;

export {
  Container,
  Title,
  StyledTextField,
};
